import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import Table from '../../../../../common/components/table'


 
export default function WebsiteLayoutCardComponent ({handleDelete,setPageData,paginationData,additionButtons,rowData,columnDefs,onEdit}: any) {
  return (
    <>

<Table
    columnData={columnDefs}
    rowData={rowData}
    onEdit={onEdit}
    additionButtons={additionButtons}
    headingName="Cards"
    paginationData={paginationData}
    setPageData={setPageData}
    onDelete={handleDelete}
    />
                           
        </>
  )
}